import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'semantic-ui-react'
import styled from 'styled-components'
import CmsCaptionImage from './CmsCaptionImage'

const StyledCard = styled(Card)`
  ${({ link }) => (link ? `
    img {
      cursor: pointer !important;
    }` : ''
)}
`

const CardElement = ({
  lang,
  style,
  header,
  description,
  src,
  settings,
  isZoomWhenHovered,
  headerAlign,
  headerSize,
  descriptionAlign,
  descriptionSize,
  fluid,
  defaultImage,
  ...othersProps
}) => {
  const headerLabel = header[lang]
  const descriptionLabel = description[lang]
  return (
    <StyledCard {...settings} style={style} fluid={fluid} {...othersProps}>
      <CmsCaptionImage
        src={src || defaultImage}
        isZoomWhenHovered={isZoomWhenHovered}
        defaultImage={defaultImage}
        imageStyle={{ background: '#ffffff' }}
      />
      {(headerLabel || descriptionLabel) && (
        <Card.Content>
          {headerLabel && (
            <Card.Header style={{ textAlign: headerAlign, fontSize: headerSize }}>
              {headerLabel}
            </Card.Header>
          )}
          {descriptionLabel && (
            <Card.Description style={{ textAlign: descriptionAlign, fontSize: descriptionSize }}>
              {descriptionLabel}
            </Card.Description>
          )}
        </Card.Content>
      )}
    </StyledCard>
  )
}
CardElement.propTypes = {
  lang: PropTypes.string,
}
CardElement.defaultProps = {
  lang: 'en',
}

export default CardElement



// WEBPACK FOOTER //
// ./src/cms/CmsCard.js